import * as React from 'react';

import './style.css';

export default function PersonImageTopCvAbstract({image, name, description, text, lecture_text, lecture_title, title=null, lang='hr'}){
    const [selection, setSelection] = React.useState(0);

    return (
        <div className="flex-column" style={{alignItems:"center", paddingTop:"2%"}}>
        <div className="flex-row" style={{width:"68%", gap:"0.5rem", justifyContent:"space-between", margin:"auto", textAlign:"left", paddingBottom:"2rem"}}>
            <div className='flex-column pillbox-like pillbox-huge light-background-element' style={{width: "95%", justifyContent:"space-between"}}>
            <div>
                <div style={{fontSize:"1.8rem"}}>{name}, {title}</div>
                <div className="person-image-description" style={{fontSize:"1.2rem"}}>{description}</div>
            </div>
            
            <div style={{textAlign:"center", paddingLeft:"0rem", paddingBottom:"3rem"}}>
            

            <p style={{color:"black", fontSize:"1.4rem"}}>{lang=="hr"?"Naslov predavanja:":"Lecture title:"}</p>
            <p className="lecture-title">{lecture_title}</p>
            </div>
            <div className="flex-row" style={{color:"black !important", fontSize:"1.5rem"}}><div className={"choice-item "+ (selection==0?"choice-item-selected":"")} onClick={()=>{setSelection(0)}}>{lang=="hr"?"Životopis":"CV"}</div><div onClick={()=>{setSelection(1)}} className={"choice-item "+ (selection==1?"choice-item-selected":"")}>{lang=="hr"?"Sažetak":"Abstract"}</div></div>
            </div>
            <div className="person-image-vert pillbox-like pillbox-huge image-square">
                <img style={{height:"100%"}} src={image}></img>
            </div>
            
        </div>
        <div className="person-image-text" style={{maxWidth:"70%", height: "30vh", overflowY:"scroll"}}>
            <p hidden={selection!=0} style={{textAlign:"center"}}><span style={{fontWeight:800}}>{name+(text[0]!=','?' ':'')}</span>{text}</p>
            <p hidden={selection!=1} style={{textAlign:"center"}}>{lecture_text}</p>
        </div>
        </div>
    )
}